import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import type { ThunkDispatch } from "redux-thunk";

import { editingAccountActions } from "../../reducers/editingAccount";
import StaffNavBar from "../StaffNavBar";
import Toast from "../Toast";

import AccountEditForm from "./AccountEditForm";

interface CurrentUserState {
  is_staff: boolean;
}

function mapStateToProps(state: { currentUser: CurrentUserState }) {
  return { ...state.currentUser };
}

interface AccountCreateProps {
  is_staff: boolean;
}

const AccountCreate: React.FC<AccountCreateProps> = ({ is_staff }) => {
  const dispatch = useDispatch<ThunkDispatch<unknown, unknown, unknown>>();

  useEffect(() => {
    if (is_staff) {
      dispatch(editingAccountActions.setInitState());
    }
  }, [is_staff, dispatch]);

  if (!is_staff) return null;

  return (
    <>
      <Toast />
      <StaffNavBar />
      <AccountEditForm />
    </>
  );
};

export default connect(mapStateToProps)(AccountCreate);
